import UPS from './UPS';
import EasyPost from './EasyPost';
import Stripe from './Stripe';
import Facebook from './Facebook';


const thirdPartyComponents = {
    UPS,
    EasyPost,
    Stripe,
    Facebook,
}


export default thirdPartyComponents